import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { Input, Button, Form } from "antd";
import { qaDetailsStore } from "../Stores/QADetailsStore";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { ButtonsRow } from "Components/Form/ButtonsRow";
import { notificationSuccess } from "utils/libHelpers/AntdNotification";

// tslint:disable-next-line: max-line-length
interface QARejectQuestionFormProps extends ModalComponentProps, WithTranslation {
  goBack: () => void;
  role: API_QA_ROLE;
}

export const QARejectQuestionForm = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<QARejectQuestionFormProps, { loading: boolean }> {
      constructor(props: QARejectQuestionFormProps) {
        super(props);
        this.state = {
          loading: false,
        };
      }

      handleSubmit = async (values) => {
        const { t, role } = this.props;
        try {
          this.setState({ loading: true });
          await qaDetailsStore.rejectQuestion(values.answer, { role });
          this.props.hideModal();
          notificationSuccess(t("Success"), t("Question rejected"));
          this.props.goBack();
        } catch (error) {
          throw error;
        } finally {
          this.setState({ loading: false });
        }
      };
      render() {
        const { t } = this.props;
        const { loading } = this.state;
        return (
          <Form onFinish={this.handleSubmit} layout="vertical">
            <Form.Item
              label={t("Reason for asking side")}
              name="answer"
              rules={[{ required: true, message: t("Please provide a rejection reason") }]}
              initialValue=""
            >
              <Input.TextArea />
            </Form.Item>
            <ButtonsRow>
              <Button type="primary" htmlType="submit" loading={loading}>
                {t("Save")}
              </Button>
            </ButtonsRow>
          </Form>
        );
      }
    }
  )
);
